import { RefObject, useEffect, useEffectEvent } from "react";

export const useDismiss = (open: boolean, dismiss: () => void, ...inside: RefObject<Element | null>[]) => {
  const dismissFrom = useEffectEvent((event: Event) => {
    if (!inside.some(ref => ref.current?.contains(event.target as Node))) dismiss();
  });

  useEffect(() => {
    if (!open) return;
    document.addEventListener("pointerdown", dismissFrom);
    window.addEventListener("scroll", dismissFrom, true);
    return () => {
      document.removeEventListener("pointerdown", dismissFrom);
      window.removeEventListener("scroll", dismissFrom, true);
    };
  }, [open]);
};
